export const apiV2Server =
  process.env.REACT_APP_apiV2Server || 'http://localhost:4000/api/v2/';
